<template>
  <div class="modular">
    <div class="radiobox">
      <div class="radio">
        <el-radio v-model="radio" :label="1">表格</el-radio>
      </div>
    </div>
    <div v-show="radio === 1" v-loading="chartLoading">
      <div class="timesheet" style="padding:20px">
          <div class="block">
            <el-date-picker
              v-model="value2"
              type="datetimerange"
              align="right"
              format="yyyy-MM-dd hh:mm:ss"
              value-format="yyyy-MM-dd hh:mm:ss"
              start-placeholder="开始日期"
              end-placeholder="结束日期">
            </el-date-picker>
            <el-button type="primary" @click="clickBtn()">查询</el-button>
          </div>
      </div>
      <el-table :data="dataList" border style="width: 100%;">
        <el-table-column type="index" align="center" width="50" fixed></el-table-column>
        <el-table-column prop="设备名称(deviceName)" header-align="center" align="center" label="设备名称">
        </el-table-column>
        <el-table-column prop="详细信息(CombinedInfo)" header-align="center" align="center" label="操作信息">
        </el-table-column>
        <el-table-column prop="records" header-align="center" align="center" label="详情">
          <template slot-scope="scope">
            <el-button @click="showDetail(scope.row)" type="text" size="small">具体数据</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="30%">
      <div style="margin-bottom:10px"><span style="color: #111">时间：</span>{{deatilList['设备接收时间(deviceReceiptTime)']}}</div>
      <div><span style="color: #111">操作信息：</span>{{deatilList['原始事件(rawEvent)']}}</div>
    </el-dialog>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="page.pageIndex"
      :page-sizes="[10, 20, 50, 100]" :page-size="page.pageSize" :total="page.totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  name: 'modularChild5',
  props: ['socUserName'],     
  data () {
    return {
      value1: '',
      value2: [],
      radio: 1,
      dialogVisible: false,
      dataList: [
        // {
        //   total: 3,
        //   aggTotal: 5,
        //   records: ''
        // },
        // {
        //   total: 1,
        //   aggTotal: 2,
        //   records: ''
        // },
        // {
        //   total: 1,
        //   aggTotal: 1,
        //   records: ''
        // }
      ],
      chartLoading: false,
      deatilList: [
      ],
      page: {
        pageIndex: 1,
        pageSize: 10,
        totalPage: 0
      },        
      endTime: "",
      username: "",
      startTime: "",
      limit: "",
      offset: ""
    }
  },
  methods: {
    sizeChangeHandle(size) {
      this.page.pageSize = size
      this.getTime()
    },
    currentChangeHandle(current) {
      this.page.pageIndex = current
      this.getTime()
    },     
    timestampToTime(timestamp) {
        var date = new Date(timestamp);//时间戳为10位需*1000，时间戳为13位的话不需乘1000
        var Y = date.getFullYear() + '-';
        var M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1):date.getMonth()+1) + '-';
        var D = (date.getDate()< 10 ? '0'+date.getDate():date.getDate())+ ' ';
        var h = (date.getHours() < 10 ? '0'+date.getHours():date.getHours())+ ':';
        var m = (date.getMinutes() < 10 ? '0'+date.getMinutes():date.getMinutes()) + ':';
        var s = date.getSeconds() < 10 ? '0'+date.getSeconds():date.getSeconds();
        var timestamp = Y+M+D+h+m+s;
        return timestamp;
    },
    getTime(page,socUserName){
      if (page) {
        this.page.pageIndex = page
      }        
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true;      
      var nowdate = new Date();
      var startTime = nowdate.setMonth(nowdate.getMonth()-1); 
      var endTime = Date.parse(new Date());
      this.timestampToTime(startTime);
      this.timestampToTime(endTime);          
      startTime = this.timestampToTime(startTime);
      endTime = this.timestampToTime(endTime);
      let params = {
        "limit": this.page.pageSize,
        "offset": this.page.pageIndex-1,        
        "endTime": endTime,
        "username": socUserName,
        "startTime": startTime
      }     
      this.getData(params)
    },
    clickBtn(page,socUserName) {  
      if (page) {
        this.page.pageIndex = page
      }            
      if (socUserName === undefined) {
        socUserName = this.socUserName
      }
      this.chartLoading = true; 
      let params = {
        "limit": this.page.pageSize,
        "offset": this.page.pageIndex-1,          
        'endTime': this.value2 ? Date.parse(this.value2[1]) : '',
        'username': socUserName,
        'startTime': this.value2 ? Date.parse(this.value2[0]) : ''
      }
      params.endTime = this.timestampToTime(params.endTime)
      params.startTime = this.timestampToTime(params.startTime)
      this.getData(params)
    },
    getData(params) {
      this.$http.post(`/front/consumer/order/soc/interface/queryMajorOperation`, params)
        .then(data => {
          if (data && data.status === 200 && data.data.code === 0) {
            // let res = this.formatterData(data.data.data)
            // this.chartsi.setOption(this.optioni)
            this.dataList = data.data.data.records
            this.page.totalPage = data.data.data.total               
          } else {
            this.$message.error(data.result.msg)
          }
          this.chartLoading = false
        })
        .catch(() => {
          this.chartLoading = false
        })
    },
    formatterData(data) {
      return []
    },
    showDetail(row) {
      this.deatilList = row
      this.dialogVisible = true
    },
    formatData(data) {
      if (!data) {
        return []
      }
      let arr = []
      data.forEach(item => {
        Object.keys(item).forEach(i => {
          arr.push(
            {
              key: i,
              value: item[i]
            }
          )
        })
      })
      return arr
    }
  },
  mounted () {
    this.getTime();
  }
}
</script>

<style lang="scss" scoped>
.modular {
  position: relative;
  .radiobox {
    pointer-events: none;
    width: 100%;
    position: absolute;
    top: -30px;
    .radio {
      pointer-events: auto;
      width: 100px;
      margin: 0 auto;
    }
  }
  .echarts {
    height: calc(100vh - 370px);
  }
}
</style>
